export default [
    {
        path: '/conciliation',
        // name: 'conciliation',
        meta: {
            isSection: true
        },
        // component: () => import('@/views/conciliation/index.vue')
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'conciliation',
                component: () => import('@/views/conciliation/index.vue')
            }
        ]
    }
];
